import { useCallback } from 'react';

const tContainer = {
  t: (key: string, _?: object) => key,
};

const initializeT = translationFunction => {
  tContainer.t = translationFunction;
};

const useT = () => useCallback(tContainer.t, []);

export { initializeT, useT };
